import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import React, { useState } from "react";
import Navbar from "./shared/pages/Navbar";
import Routing from "./Routing";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import darkScrollbar from "@mui/material/darkScrollbar"; // Optional for dark mode

import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { faIR } from "@mui/material/locale";
import { SnackbarProvider } from "notistack";
// import Zoom from "./shared/components/Zoom";
import Zoom from "@mui/material/Zoom";
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
function RTL(props) {
  return <CacheProvider value={cacheRtl}>{props.children}</CacheProvider>;
}

const App = () => {
  const [mode, setMode] = useState(false);
  const Theme = createTheme(
    {
      palette: {
        mode: mode ? "light" : "dark",
        primary: {
          main: mode ? "#009f9b" : "#449db1",
        },
        secondary: {
          main: mode ? "#613391" : "#9f6dd5",
        },
        background: {
          default: mode ? "#e0e0e0" : "#0b1116",
          paper: mode ? "#f9f9f8" : "#051d2b",
        },
        error: {
          main: mode ? "#b73232" : "#b73232",
          dark: mode ? "#b73232" : "#b73232",
          light: mode ? "#b73232" : "#b73232",
        },
        warning: {
          main: mode ? "#ffda0c" : "#ffda0c",
          dark: mode ? "#ffda0c" : "#ffda0c",
          light: mode ? "#ffda0c" : "#ffda0c",
        },
        success: {
          main: mode ? "#22975c" : "#22975c",
          dark: mode ? "#22975c" : "#22975c",
          light: mode ? "#22975c" : "#22975c",
        },
      },
      direction: "rtl",
    },
    faIR
  );
  return (
    <ThemeProvider theme={Theme}>
      <RTL>
        <CssBaseline />
        <SnackbarProvider
          TransitionComponent={Zoom}
          autoHideDuration={3000}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <Routing modeHandler={setMode} mode={mode} />
        </SnackbarProvider>
      </RTL>
    </ThemeProvider>
  );
};

export default App;
